import axios from 'axios'

import { resolveRequest, TAsyncRequestResult } from 'utility-tools/module/requests'
import { requestWithoutAuthentication } from 'nexchange-service/module/auth'
import { appConfigContext } from 'nexchange-service/appServiceConfig'
import constants from 'nexchange-service/constants'
import { getTimezoneHeader } from 'utility-tools/module/timezone'

import { getAnonymousOrderAuthToken, setAnonymousOrderAuthToken } from '../anonymousOrders'
import { IOrderCreationDto, IOrderDetailsApiDto, IWithdrawAddressApiDto } from './api.types'
import { mapOrderCreationDtoToReqApiDto, mapSellOrderCreationDtoToReqApiDto } from './mappers'

const { API_URL } = constants

const USE_TEST_API = false // !!! DANGER !!! because effects both obron and yoa websites

const requestRecentOrders = async (orderListSize: number = null) =>
    axios.get(
        `${API_URL}/orders/?page=1&page_size=${orderListSize || appConfigContext.getAppConfig().RECENT_ORDERS_SIZE
        }`,
    )

const requestRecentUserOrders = async () => axios.get(`${API_URL}/users/me/orders/`)

const requestCreateOrder = async (
    orderCreationDto: IOrderCreationDto,
): Promise<IOrderDetailsApiDto> => {
    let orderCreationReqApiDto = {}
    if (orderCreationDto.order_type === 0) {
        orderCreationReqApiDto = mapSellOrderCreationDtoToReqApiDto(orderCreationDto)
    } else {
        orderCreationReqApiDto = mapOrderCreationDtoToReqApiDto(orderCreationDto)
    }

    // Testing API: https://sapi.n.exchange/en/api/v1/orders/
    // World pay testing cards: http://support.worldpay.com/support/kb/bg/testandgolive/tgl5103.html
    const testingWorldPayDto = {
        ...orderCreationReqApiDto,
        amount_quote: 100.16,
        pair: {
            name: 'LTCEUR',
        },
    }

    // Add timezone header for order creation requests
    const headers = {
        'Content-Type': 'application/json',
    }

    try {
        // if (typeof window !== 'undefined') {
        //     headers['Timezone'] = getTimezoneHeader()
        // }
    } catch (error) {
        // Ignore timezone header errors
    }

    return (
        USE_TEST_API
            ? axios.post(`https://sapi.n.exchange/en/api/v1/orders/`, testingWorldPayDto, { headers }) // Testing worldpay
            : axios.post(`${API_URL}/orders/`, orderCreationReqApiDto, { headers })
    ).then(response => {
        const { data } = response
        const { token: anonymousAuthToken, unique_reference: orderId } = data

        //setAnonymousOrderAuthToken(orderId, anonymousAuthToken)
        return data
    })

    // TODO: temporary workaround until registered user can use ref codes
    // return requestWithoutAuthentication(async () =>
    //     (USE_TEST_API
    //         ? axios.post(`https://sapi.n.exchange/en/api/v1/orders/`, testingWorldPayDto) // Testing worldpay
    //         : axios.post(`${API_URL}/orders/`, orderCreationReqApiDto)
    //     ).then(response => {
    //         const { data } = response
    //         const { token: anonymousAuthToken, unique_reference: orderId } = data
    //
    //         setAnonymousOrderAuthToken(orderId, anonymousAuthToken)
    //         return data
    //     }),
    // )
}


const requestSetOrderWalletAddress = async (
    orderId: string,
    walletAddressDto: {
        address: string
        extraId?: string
    },
) => {
    const { extraId, address } = walletAddressDto
    const walletAddressApiDto = <IWithdrawAddressApiDto>{ extra_id: extraId, address }

    return axios.patch(`${API_URL}/orders/${orderId}/`, {
        withdraw_address: walletAddressApiDto,
    })

    // TODO: temporary workaround until registered user can use ref code`
    // requestWithoutAuthentication(async () => {
    //     const anonymousAuthToken = getAnonymousOrderAuthToken(orderId)
    //
    //     const { extraId, address } = walletAddressDto
    //     const walletAddressApiDto = <IWithdrawAddressApiDto>{ extra_id: extraId, address }
    //
    //     return axios
    //         .patch(
    //             `${API_URL}/orders/${orderId}/`,
    //             {
    //                 withdraw_address: walletAddressApiDto,
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${anonymousAuthToken}`,
    //                 },
    //             },
    //         )
    //         .then(response => {
    //             const { data } = response
    //             return data
    //         })
    // })
}

const requestOrderDetails = async (orderId: string): TAsyncRequestResult<IOrderDetailsApiDto> =>
    resolveRequest<IOrderDetailsApiDto>(
        USE_TEST_API
            ? axios.get(`https://sapi.n.exchange/en/api/v1/orders/${orderId}/`) // Testing worldpay
            : axios.get(`${API_URL}/orders/${orderId}/`),
    )

export {
    requestCreateOrder,
    requestRecentOrders,
    requestRecentUserOrders,
    requestSetOrderWalletAddress,
    requestOrderDetails,
}
